var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"new-button"},[(_setup.props.isNewContent && _vm.show)?_c('div',{staticClass:"new-button_text color-f fs12 ellipsis",style:(_setup.styleObj),attrs:{"title":_setup.content}},[_vm._v(" "+_vm._s(_setup.content)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }